import React, { useState, useEffect } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { MdDeleteOutline } from "react-icons/md";
import { FaArrowLeftLong } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import "../Inventory/Inventory.css";
import "./Quotations.css";
import { axiosInstance } from "../../../axiosInstance";
import { ToastContainer, toast } from "react-toastify";
import Stack from "@mui/material/Stack";
import CircularProgress from "@mui/material/CircularProgress";
import Select from "react-select";
import { IoIosSearch } from "react-icons/io";
import { components } from "react-select";

export const NewQuotations = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [quotationId, setQuotationId] = useState();
  const [customerName, setCustomerName] = useState();
  const [phoneNumber, setPhoneNumber] = useState();
  const [address, setAddress] = useState();
  const [city, setCity] = useState();
  const [state, setState] = useState();
  const [gstin, setGstin] = useState();
  const [additionalNote, setAdditionalNote] = useState();
  const [dropdownProductcode, setDropdownProductCode] = useState();

  // search icon in product code
  const SearchDropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <IoIosSearch size={16} color="#92959c" />
      </components.DropdownIndicator>
    );
  };

  const [addStockRow, setAddStockRow] = useState([
    {
      id: Date.now() + Math.random(),
      productCode: "",
      productId: "",
      product: "",
      // category: "",
      uom: "",
      qty: "",
      price: "",
      total: "",
    },
  ]);
  // Add stock  new row
  const handleAddStockRow = () => {
    setAddStockRow((prevRows) => [
      ...prevRows,
      {
        id: Date.now() + Math.random(), //it creates a unique ID based on the exact millisecond the row was added.
        productCode: "",
        productId: "",
        product: "",
        // category: "",
        uom: "",
        qty: "",
        price: "",
        total: "",
      },
    ]);
  };

  // Delete add stock row
  const handleDeleteStockRow = (id) => {
    setAddStockRow((prevRows) => prevRows.filter((row) => row.id !== id));
  };
  const totalQty = addStockRow.reduce(
    (sum, row) => sum + Number(row.qty || 0),
    0,
  );
  const totalValue = addStockRow.reduce(
    (sum, row) => sum + Number(row.total || 0),
    0,
  );
  function handleQtyChange(rowId, value) {
    const qty = Number(value);

    setAddStockRow((prevRows) =>
      prevRows.map((row) =>
        row.id === rowId //only update the matching row here  both row.id===rowId is from frontend
          ? {
              ...row,
              qty: qty,
              total: qty * Number(row.price || 0),
            }
          : row,
      ),
    );
  }
  async function fetchProductDetails(rowId, productId) {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `inventory/product/${productId}`,
      );
      if (response.data.status === "success" || response.status === 200) {
        const details = response.data.data;

        setAddStockRow((prevRows) =>
          prevRows.map((row) =>
            row.id === rowId // only update the matching row here  both row.id===rowId is from frontend
              ? {
                  ...row,
                  backendId: details.id,
                  productId: productId,
                  // productCode: productCode,
                  productCode: details.product_code,
                  product: details.product_name || "",
                  // category: details.category || "",
                  uom: details.uom || "",
                  // defaultCost: details.default_cost_price || "",
                  qty: row.qty || 1,
                  price: details.default_cost_price || "",
                  total: (row.qty || 1) * details.default_cost_price,
                }
              : row,
          ),
        );
        console.log(
          response.data.message || "Product details fetched successfully",
        );
        // toast.success(
        //   response.data.message || "Product details fetched successfully"
        // );
      }
    } catch (error) {
      console.log("Failed to fetch product details", error);
      toast.error(
        error.response?.data?.message || "Failed to fetch product details",
      );
    } finally {
      setLoading(false);
    }
  }
  // useEffect(() => {
  //   addStockRow.forEach((row) => {
  //     if (!row.productCode) {
  //       fetchProductDetails(row.id, "pc-01"); // auto-load first option
  //     }
  //   });
  // }, []);
  async function LoadDropdownProductcode() {
    try {
      const response = await axiosInstance.get(
        "/inventory/distributor/product-code/",
      );
      if (response.data.status === "success" || response.status === 200) {
        setDropdownProductCode(response.data.data);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to load dropdown");
      console.log("Failed to load dropdown");
    }
  }
  useEffect(() => {
    LoadDropdownProductcode();
  }, []);
  const productCodeOptions = dropdownProductcode?.map((item) => ({
    // value: item.product_code,
    value: item.id,
    label: item.product_code,
  }));
  const productNameOptions = dropdownProductcode?.map((item) => ({
    // value: item.product_code,
    value: item.id,
    label: item.product_name,
  }));

  async function handleSave() {
    try {
      setLoading(true);
      const products = addStockRow.map((item) => ({
        product_id: item.backendId,
        qty: Number(item.qty) || 0,
        total: Number(item.total) || 0,
      }));
      const payload = {
        customer_name: customerName?.trim() || "",
        phone_number: phoneNumber,
        // payment_method:,
        address: address,
        city: city,
        state: state,
        gstin: gstin,
        additional_notes: additionalNote,
        products: products,
      };
      const response = await axiosInstance.post("/quotation/create/", payload);
      if (response.data.status === "success" || response.status === 200) {
        toast.success(response.data.message || "submitted successfully");
        console.log("submitted successfully");
        setTimeout(() => {
          navigate("/state-quotations");
        }, 3000);
      }
    } catch (error) {
      toast.error(error.response.data.message || "Failed to submit");
      console.log("Failed to submit");
    } finally {
      setLoading(false);
    }
  }
  return (
    <>
      {loading && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            backgroundColor: "rgba(0, 0, 0, 0.3)",
            zIndex: 9999,
          }}
        >
          <Stack spacing={2} direction="row" alignItems="center">
            <CircularProgress size={40} sx={{ color: "var(--color-theme)" }} />
          </Stack>
        </div>
      )}
      <ToastContainer />

      <div className="inventoryContainer">
        <div className="container">
          <div className="d-flex gap-1 mb-2">
            <span className="me-2">
              <Link to="/state-quotations" style={{ color: "black" }}>
                <FaArrowLeftLong />
              </Link>
            </span>
            <div className="addModalTitle">Create New Quotation</div>
          </div>

          {/* Reference No & Date */}
          <div className="bulkAddGrid">
            <div>
              <label>Quotation ID</label>
              <input
                type="text"
                placeholder="Enter Quotation ID"
                value={quotationId}
                onChange={(e) => setQuotationId(e.target.value)}
              />
            </div>
            <div>
              <label>Customer Name</label>
              <input
                type="text"
                placeholder="Enter Customer Name"
                value={customerName}
                onChange={(e) => setCustomerName(e.target.value)}
              />
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>Phone Number</label>
              <input
                type="number"
                placeholder="Enter Phone Number"
                value={phoneNumber}
                onChange={(e) => setPhoneNumber(e.target.value)}
              />
            </div>
            <div>
              <label>Address</label>
              <input
                type="text"
                placeholder="Enter Address"
                value={address}
                onChange={(e) => setAddress(e.target.value)}
              />
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>City</label>
              <input
                type="text"
                placeholder="Enter City"
                value={city}
                onChange={(e) => setCity(e.target.value)}
              />
            </div>
            <div>
              <label>State</label>
              <input
                type="text"
                placeholder="Enter State"
                value={state}
                onChange={(e) => setState(e.target.value)}
              />
            </div>
          </div>
          <div className="bulkAddGrid">
            <div>
              <label>GSTIN</label>
              <input
                type="text"
                placeholder="Enter GSTIN"
                value={gstin}
                onChange={(e) => setGstin(e.target.value)}
              />
            </div>
            <div>{""}</div>
          </div>

          {/* Table */}

          <div className="dashboardTableContainer">
            <TableContainer component={Paper}>
              <Table stickyHeader aria-label="sticky table">
                <TableHead className="dashboadTableHeader">
                  <TableRow>
                    <TableCell>Product Code</TableCell>
                    <TableCell align="left">Product Name</TableCell>

                    <TableCell align="left">UOM</TableCell>
                    <TableCell align="left">Qty</TableCell>
                    <TableCell align="left">Price/Unit (₹)</TableCell>
                    <TableCell align="left">Total Cost</TableCell>
                    <TableCell align="left">Actions</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {addStockRow.map((row) => (
                    <TableRow
                      key={row.id}
                      sx={{
                        "&:last-child td, &:last-child th": { border: 0 },
                      }}
                      className="dashboardTableBody"
                    >
                      <TableCell align="left">
                        {/* <select
                          className="addModalQtySelect"
                          value={row.productCode}
                          onChange={(e) => {
                            fetchProductDetails(row.id, e.target.value);
                          }}
                        >
                          <option value={""} selected disabled>
                            Select
                          </option>
                          {dropdownProductcode?.map((drop) => (
                            <option value={drop.product_code}>
                              {drop.product_code}
                            </option>
                          ))}
                        </select> */}
                        <Select
                          className="productCodeSelect"
                          classNamePrefix="select"
                          options={productCodeOptions}
                          placeholder="Search"
                          // value={
                          //   row.productCode
                          //     ? {
                          //         value: row.productCode,
                          //         label: row.productCode,
                          //       }
                          //     : null
                          // }
                          value={
                            row.productId
                              ? {
                                  value: row.productId,
                                  label: row.productCode,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            fetchProductDetails(
                              row.id,
                              selected?.value,
                              selected?.label,
                            )
                          }
                          isSearchable={true}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          components={{
                            DropdownIndicator: SearchDropdownIndicator, // 🔍 replace caret
                          }}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // remove blue glow
                              borderColor: "#92959c",
                              "&:hover": { borderColor: "#92959c" },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: 4,
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                        />
                      </TableCell>

                      <TableCell
                        align="left"
                        sx={{
                          width: "200px",
                          minWidth: "200px",
                        }}
                      >
                        <Select
                          className="productCodeSelect"
                          classNamePrefix="select"
                          options={productNameOptions}
                          placeholder="Search"
                          // value={
                          //   row.productCode
                          //     ? {
                          //         value: row.productCode,
                          //         label: row.productCode,
                          //       }
                          //     : null
                          // }
                          value={
                            row.productId
                              ? {
                                  value: row.productId,
                                  label: row.product,
                                }
                              : null
                          }
                          onChange={(selected) =>
                            fetchProductDetails(row.id, selected?.value)
                          }
                          isSearchable={true}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          components={{
                            DropdownIndicator: SearchDropdownIndicator, // 🔍 replace caret
                          }}
                          styles={{
                            control: (base, state) => ({
                              ...base,
                              boxShadow: "none", // remove blue glow
                              borderColor: "#92959c",
                              "&:hover": { borderColor: "#92959c" },
                            }),
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                            dropdownIndicator: (base) => ({
                              ...base,
                              padding: 4,
                            }),
                            indicatorSeparator: () => ({
                              display: "none",
                            }),
                          }}
                        />
                        {/* {row.product || "---"} */}
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.uom}
                            placeholder="UOM"
                          />
                        </span> */}
                        {row.uom || "---"}
                      </TableCell>

                      <TableCell align="left">
                        <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.qty}
                            placeholder="Qty"
                            onChange={(e) =>
                              handleQtyChange(row.id, e.target.value)
                            }
                          />
                        </span>
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                          <input
                            type="text"
                            value={row.default_cost_price}
                            placeholder="Cost"
                          />
                        </span> */}
                        {row.price || "---"}
                      </TableCell>

                      <TableCell align="left">
                        {/* <span className="addModalQtyInput">
                        <input
                          type="text"
                          value={row.total}
                          placeholder="Total"
                        />
                      </span> */}
                        {row.total || "---"}
                      </TableCell>

                      <TableCell align="left">
                        <MdDeleteOutline
                          style={{ cursor: "pointer" }}
                          onClick={() => handleDeleteStockRow(row.id)}
                        />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          {/* Add Row Button */}
          <div
            className="addRowText"
            onClick={handleAddStockRow}
            style={{ cursor: "pointer", marginTop: "10px" }}
          >
            + Add Row
          </div>

          {/* Totals */}
          <div className="addModalTotalContainer">
            <div>
              <div className="addModalContent">
                <span>Total Products Received(Qty):</span>
                <span>{totalQty} nos</span>
              </div>
              <div className="addModalContent">
                <span>Total Value:</span>
                <span>₹{totalValue.toLocaleString()}</span>
              </div>
            </div>
          </div>

          {/* Notes */}
          <div className="bulkAddTextGrid">
            <div>
              <label>Additional Notes</label>
            </div>
            <div>
              <textarea
                placeholder="Type here"
                rows={4}
                value={additionalNote}
                onChange={(e) => setAdditionalNote(e.target.value)}
              ></textarea>
            </div>
          </div>

          {/* Buttons */}
          <div className="d-flex justify-content-end">
            <div
              className="addModalButtons"
              style={{ marginTop: "20px", display: "flex", gap: "10px" }}
            >
              {/* <button className="addBtnCancel">Cancel</button> */}
              <button className="addBtnSave" onClick={handleSave}>
                Generate Quotation
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
